<template>
  <div
    v-if="formGroup"
    class="form-group"
    :style="{ marginBottom: formGroupMarginBottom ? '15px' : null }"
  >
    <label
      v-if="title"
      class="control-label"
    >
      {{ title }}
    </label>
    <span
      v-if="hasSlot('addonLeft')"
      class="input-group-addon"
    >
      <slot name="addonLeft" />
    </span>
    <div
      v-if="inputGroup"
      class="input-group"
    >
      <span
        v-if="hasSlot('addonLeft')"
        class="input-group-addon"
      >
        <slot name="addonLeft" />
      </span>
      <!--
        Вызывается при изменении значения.

        @event input
        @property {String} value Значение.
      -->
      <input
        v-mask="inputMask"
        :type="type"
        :class="[formControlClass, getSizeClass]"
        :placeholder="placeholder"
        :value="value"
        :maxlength="maxLength"
        @input="$emit('input', $event.target.value)"
      >
      <span
        v-if="hasSlot('addonRight')"
        class="input-group-addon"
      >
        <slot name="addonRight" />
      </span>
    </div>
    <input
      v-else
      v-mask="inputMask"
      :type="type"
      :class="[formControlClass, getSizeClass]"
      :placeholder="placeholder"
      :value="value"
      :maxlength="maxLength"
      @input="$emit('input', $event.target.value)"
    >
  </div>
  <div
    v-else-if="inputGroup"
    class="input-group"
  >
    <span
      v-if="hasSlot('addonLeft')"
      class="input-group-addon"
    >
      <slot name="addonLeft" />
    </span>
    <input
      v-mask="inputMask"
      :type="type"
      :class="[formControlClass, getSizeClass]"
      :placeholder="placeholder"
      :value="value"
      :maxlength="maxLength"
      @input="$emit('input', $event.target.value)"
    >
    <span
      v-if="hasSlot('addonRight')"
      class="input-group-addon"
    >
      <slot name="addonRight" />
    </span>
  </div>
  <input
    v-else
    v-mask="inputMask"
    :type="type"
    :class="[formControlClass, getSizeClass]"
    :placeholder="placeholder"
    :value="value"
    :maxlength="maxLength"
    @input="$emit('input', $event.target.value)"
  >
</template>

<script>
import slots from '../../mixins/slots'

/**
 * Input.
 */
export default {
  name: 'CInput',
  mixins: [slots],
  props: {
    /**
     * Текущее значение.
     *
     * @model
     */
    value: {
      validator (value) {
        return ['string', 'number'].includes(typeof value) || value === null
      },
      required: true
    },
    /**
     * Тип.
     */
    type: {
      type: String,
      default: 'text'
    },
    /**
     * Текст плейсхолдера.
     */
    placeholder: {
      type: String,
      default: 'Введите текст...'
    },
    /**
     * Размер.
     *
     * @values sm, lg
     */
    size: {
      type: String,
      default: ''
    },
    /**
     * Добавлять ли к input-у класс form-control.
     */
    formControl: {
      type: Boolean,
      default: true
    },
    /**
     * Обернуть ли input в div.form-group.
     */
    formGroup: {
      type: Boolean,
      default: false
    },
    /**
     * Отступ снизу от div.form-group.
     */
    formGroupMarginBottom: {
      type: Boolean,
      default: false
    },
    /**
     * Обернуть ли input в div.input-group.
     */
    inputGroup: {
      type: Boolean,
      default: false
    },
    /**
     * Текст для лейбла.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Максимальное количество символов значения.
     */
    maxLength: {
      type: Number,
      default: 255
    },
    /**
     * Маска ввода.
     */
    inputMask: {
      type: String,
      default: ''
    }
  },
  computed: {
    /**
     * Возвращает класс размера input-а.
     *
     * @returns {string}
     */
    getSizeClass () {
      if (!this.size) {
        return ''
      }

      return 'input-' + this.size
    },
    /**
     * Возвращает класс form-control для input-а, если установлено свойство formControl.
     *
     * @returns {string}
     */
    formControlClass () {
      return this.formControl ? 'form-control' : ''
    }
  }
}
</script>
